import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
        <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 py-16 md:flex-row md:items-end md:justify-between">
            <div>
                <button
                    data-testid="footer-logo-button"
                    onClick={() => scrollToId("top")}
                    className="flex items-center"
                >
                    <img
                        src="/images/logo.png"
                        alt="RAV4 Buyers Club"
                        className="h-16 w-16 bg-white object-contain p-1"
                    />
                </button>
                <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-500">
                    A members-only buying club securing 2026 Toyota RAV4 allocations for a
                    one-time $399 fee. Not affiliated with Toyota Motor Corporation.
                </p>
            </div>
            <div className="text-sm text-zinc-500">
                <p className="text-xs uppercase tracking-[0.25em] text-zinc-600">Membership desk</p>
                <a
                    data-testid="footer-email-link"
                    href="mailto:membership@rav4buyersclub.com"
                    className="mt-3 block text-white transition-colors duration-300 hover:text-[#2563EB]"
                >
                    membership@rav4buyersclub.com
                </a>
                <p className="mt-6 text-xs text-zinc-600">
                    © 2026 RAV4 Buyers Club. All rights reserved.
                </p>
            </div>
        </div>
    </footer>
);
